import { render, staticRenderFns } from "./OctList.vue?vue&type=template&id=fe5f345e&scoped=true&"
import script from "./OctList.vue?vue&type=script&lang=js&"
export * from "./OctList.vue?vue&type=script&lang=js&"
import style0 from "./OctList.vue?vue&type=style&index=0&id=fe5f345e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe5f345e",
  null
  
)

export default component.exports